module.exports = __webpack_public_path__ + "static/about-roject-img-main-1906a7faf874f6d332eb47b0a6469fa7.png";